import { render, staticRenderFns } from "./NewRFQRequest.vue?vue&type=template&id=47a97291&scoped=true"
import script from "./NewRFQRequest.vue?vue&type=script&lang=js"
export * from "./NewRFQRequest.vue?vue&type=script&lang=js"
import style0 from "./NewRFQRequest.vue?vue&type=style&index=0&id=47a97291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a97291",
  null
  
)

export default component.exports